import React, {useState,useEffect,useRef} from "react";
import { useTranslate } from 'react-redux-multilingual';
import { CardPerso,CarouselImage,ProfilActionButton,Loading,DeleteActionButton,ColumDataTableReorganize,articleColumnGenerate,customFieldsColumnGenerate,priceSuppColumnGenerate,tauxTvaColumnGenerate,enumereColumnGenerate,articleEditionDatatable,articleDataGenerator,ToastPopUp,AddMarkExportForm,ExportArticleButton,ImportArticleSupplementList,useLocalStorage,articlePriceUnitSuppDataGenerator} from "@gull";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import cellEditFactory from 'react-bootstrap-table2-editor';
import axios from 'axios'
import swal from "sweetalert2"
import Moment from 'react-moment';
import { useCookies} from 'react-cookie';
import {scrollXDataTable} from 'app/scrollXDataTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faEdit } from '@fortawesome/free-solid-svg-icons'
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useParams } from "react-router-dom";
import {articleListErp} from 'app/columnsArticleListeDataTable'
import FormulaireAjoutArticleSupplementList from './FormulaireAjoutArticleSupplementList'
import {Tabs, Tab} from "react-bootstrap";
import ModalSelectArticlePrice from "@gull/components/modal/ModalSelectArticlePrice";

const useLoad = (id) => {
    const t = useTranslate();
    const [allSupplementListDetail,setAllSupplementListDetail]=useState([])
    const [allSupplementListDetailSize,setAllSupplementListDetailSize]=useState(0)
    const [loading,setLoading]=useState(true)
    const [reloadData,setReloadData] = useState(Date.now())
    const [listName,setListName]=useState(false)
    const [supplementListId,setSupplementListId]=useState(false)

    useEffect(function () {
        (async function() {
            const response  = await axios.get(process.env.REACT_APP_API_URL+"api/erp/supplement_list/one/"+id,
            ).then((response) => {
                if(!response.data.valid){
                    let interms='';
                    var keys = Object.keys(response.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=response.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach(interm=>messageError+=t(interm)+'. ')
                    messageError=messageError.replace('undefined','');
                    swal.fire(messageError, "", "error");
                }
                else{
                    setListName(response.data.data.name)
                    setSupplementListId(response.data.data.id)
                    setAllSupplementListDetail(response.data.data.supplement_list_detail)
                    setAllSupplementListDetailSize(Object.keys(response.data.data.supplement_list_detail).length)
                }
            }).catch((error) => {
                if(error=='end_session') return;
                swal.fire(t('unknowError'), "", "error");
            })
            setLoading(false)
        })()
    }, [reloadData])

    return [loading,allSupplementListDetail,setAllSupplementListDetail,setReloadData,listName,supplementListId,reloadData,allSupplementListDetailSize,setAllSupplementListDetailSize]
} 

const CustomDataTable = (props) => {
    const t = useTranslate();
    
    useEffect(() => {
        scrollXDataTable(window.screen.width,props.columnShow.length)
    }, [window.screen.width,props.columnShow.length]);
    
    return (
        <BootstrapTable
            {...props.propst.baseProps}
            bootstrap4
            pagination={paginationFactory(props.paginationOptions)}
            noDataIndication={t('tableNoData')}
            defaultSortDirection={props.defaultSortDirection}
            cellEdit={cellEditFactory({
                mode: 'dbclick',
                blurToSave: true,
            })}
            hover
            condensed
            responsive
        />
    );
};

const ItemsSupplementListDetailTable = (props) => {
    const t = useTranslate();
    const { id } = useParams();

    const [loading,allSupplementListDetail,setAllSupplementListDetail,setReloadData,listName,supplementListId,reloadData,allSupplementListDetailSize,setAllSupplementListDetailSize]=useLoad(id)

    const [cookies, setCookie] = useCookies(['supplement_list_detail_fields','supplement_list_detail_reorganize']);
    const [localStorage, setLocalStorage] = useLocalStorage(['supplement_list_detail_fields','supplement_list_detail_reorganize']);
    useEffect(() => {//ce use effect permet de faire la transistion entre l'ancienne utilisation des cookies pour la gestion des datatable et la nouvell gestion via localStorage. Il faudra supprimer cela et l'utilisation des cookies à partir de juin 2026
        if(!localStorage.supplement_list_detail_fields && cookies.supplement_list_detail_fields){
            setLocalStorage('supplement_list_detail_fields',cookies.supplement_list_detail_fields);
        }
        if(!localStorage.supplement_list_detail_reorganize && cookies.supplement_list_detail_reorganize){
            setLocalStorage('supplement_list_detail_reorganize',cookies.supplement_list_detail_reorganize);
        }
    }, []);
    const [lang, setLang] = useCookies(['lang']);
    const [columnOrganize,setColumnOrganize]=useState([])
    const [showColumnOrganize,setShowColumnOrganize]=useState(false) 

    const [perPage,setPerPage]=useState(50)

    const [toast,setToast]=useState(false) 
    const [table,setTable]=useState('article') 

    //Pour le carousel
    const [showCarousel,setShowCarousel]=useState(false) 
    const [modalItemName,setModalItemName]=useState('') 
    const [modalImage,setModalImage]=useState('') 
    
    // Pour l'édition de la quantité maximum
    const inputQteRef = useRef({})
    const [validButton,setValidButton]=useState(false)
    const [quantityOfItem,setQuantityOfItem]=useState({})
    const [showButtonValidate,setShowButtonValidate]=useState(false)

    // Pour l'édition de la catégorie tarifaire
    const [showEditPriceModal,setShowEditPriceModal]=useState(false)
    const [editingDetail,setEditingDetail]=useState(null)
    const [selectedEditPriceId,setSelectedEditPriceId]=useState(null)
    const [loadingEditModal,setLoadingEditModal]=useState(false)
    
    let cookieLecture = ['internalid','name','reference','price','action','max_quantity','article_price_name'];
    if(localStorage.supplement_list_detail_fields){
        let columnShowVar = localStorage.supplement_list_detail_fields;
        cookieLecture = columnShowVar.split(',')
    }
    const [columnShow,setColumnShow] = useState(cookieLecture)   

    let current_date = new Date()
    let timestampdate = current_date.setDate(current_date.getDate() + 90)
    let expire_date = new Date(timestampdate)

    const headerSortingStyle = { backgroundColor: '#c8e6c9' };

    //partie qui concerne l'export et permet d'exporter le tableau dans l'ordre dans lequel il est affiché 
    const [headerColumnShowExport,setHeaderColumnShowExport]=useState('') 
    const [addMark,setAddMark]=useState(true) 
    useEffect(function () {
        let headerColumnShowExportArr = [] 
        
        columnOrganize.map(value=>{
            if(columnShow.includes(value.dataField)) headerColumnShowExportArr.push(value.dataField)
        })
        setHeaderColumnShowExport(headerColumnShowExportArr.join(',').replace('action,',''))
    }, [columnShow,columnOrganize])

    let headerAllExport = (localStorage.supplement_list_detail_reorganize) ? localStorage.supplement_list_detail_reorganize.replace('action,masque,','') : 'all'
    //End
    
    const deleteListeArticle = async (supplementListDetailId) => {
        const response  = await axios.post(process.env.REACT_APP_API_URL+"api/erp/supplement_list/remove_item/"+supplementListDetailId
        ).then((response) => {
            let updateList = allSupplementListDetail.filter(value=>value.id!=supplementListDetailId)
            setAllSupplementListDetail(updateList)
            setAllSupplementListDetailSize(Object.keys(response.data.data.supplement_list_detail).length)
            setReloadData(Date.now())
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
    }

    const handleOpenEditPrice = (detail) => {
        setEditingDetail(detail)
        setSelectedEditPriceId(detail.article_price_id ?? null)
        setShowEditPriceModal(true)
    }

    const handleConfirmEditPrice = async () => {
        setLoadingEditModal(true)
        await axios.put(process.env.REACT_APP_API_URL+"api/erp/supplement_list/edit_item/"+editingDetail.id, {
            article_price_id: selectedEditPriceId
        }).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
            } else {
                setReloadData(Date.now())
                setShowEditPriceModal(false)
                setEditingDetail(null)
                setSelectedEditPriceId(null)
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let messageError = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(messageError), "", "error");
        })
        setLoadingEditModal(false)
    }

    const openModalCarousel = (image,itemName) =>{
        setModalImage(image)
        setModalItemName(itemName)
        setShowCarousel(true)
    }

    const closeModalCarousel = () =>{
        setModalImage('')
        setModalItemName('')
        setShowCarousel(false)
    }

    useEffect(function () {
        if(Object.keys(allSupplementListDetail).length!=0){
            let obj = {}
            allSupplementListDetail.map(value => {
                obj[value.id] = value.max_quantity
                inputQteRef.current[value.id] = React.createRef();
            })

            setQuantityOfItem(obj)
        }
    }, [allSupplementListDetail])

    const handleFocus = (inputRef) => {
        if(inputRef.current){
            inputRef.current.select()
        }
    };

    const handleChangeQte = (e,idSupplementDetail) => {
        setQuantityOfItem({...quantityOfItem, [idSupplementDetail]:e.target.value})
        setShowButtonValidate(false)

        //quand on fait une modification, on check si il y a une une nouvelle quantité de renseignée et on affiche le bouton valider
        allSupplementListDetail.map(value=>{
            if(value.id == idSupplementDetail){
                if(value.max_quantity!=e.target.value){
                    setShowButtonValidate(true)
                }  
            }else{
                if(value.max_quantity!=quantityOfItem[value.id]){
                    setShowButtonValidate(true)
                }
            }
        })
    };

    const handleSubmitEditQte = async () => {
        let supplementDetailIds = []
        let qteMaxSupplementListDetail = []
        Object.entries(quantityOfItem).map(([key,value])=>{
            supplementDetailIds.push(key)
            qteMaxSupplementListDetail.push(value)
        })

        setValidButton(true)

        const response  = await axios.put(process.env.REACT_APP_API_URL+"api/erp/supplement_list/mass_edit/"+id,{
            supplement_list_detail:supplementDetailIds,
            max_quantity:qteMaxSupplementListDetail
        }).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'. ')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError, "", "error");
                setValidButton(false)
            }
            else{
                setReloadData(Date.now())
                setShowButtonValidate(false)
                setValidButton(false)
            }
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
            setValidButton(false)
        })
    };

    let datas = new Array
    allSupplementListDetail && allSupplementListDetail.length!=0 && allSupplementListDetail.forEach((value,ind)=>{
        let obj = {
            max_quantity: <input ref={inputQteRef.current[value.id]} onFocus={()=>handleFocus(inputQteRef.current[value.id])} disabled={validButton} type="number" value={quantityOfItem[value.id]} className="form-control form-control-sm" onChange={(e)=>handleChangeQte(e,value.id)}/>,
            id:value.id,
            internalid: value.article?.internalid,
            name:value.article.name,
            article_price_name: value.article_price?.name || '',
            created_at: <Moment format="DD/MM/YYYY">{value.created_at}</Moment>,
            masque:'',
            action:
                <span className="d-flex justify-content-between">
                    <ProfilActionButton path={'/erp/article/edit/'+value.article.id}/>
                    <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip>{t('selectArticlePrice')}</Tooltip>}
                    >
                        <span
                            className="text-primary"
                            style={{cursor:'pointer'}}
                            onClick={()=>handleOpenEditPrice(value)}
                        >
                            <FontAwesomeIcon icon={faEdit} />
                        </span>
                    </OverlayTrigger>
                    <DeleteActionButton deleteFunctionArgument={value.id} actionType={'typeDeleteX'} nameType={'delete'} toDelete={value.article.name} customClickEvent={deleteListeArticle}/>
                </span>,
            index:ind
        }
        articleDataGenerator(obj,value.article,t,openModalCarousel)
        articlePriceUnitSuppDataGenerator(obj,value.article,props.suppPrice)
        props.customFields.forEach((item,index)=>{
            if(value.article.custom_fields){
                obj[item.name]=value.article.custom_fields[item.name]
            }
        })

        for (let i=0; i<props.maxConditionnement; i++){
            let numeroEnumere = i+1
            obj['name_'+numeroEnumere]= (value.article.hasOwnProperty('name_'+numeroEnumere) && value.article['name_'+numeroEnumere]!=null) ? value.article['name_'+numeroEnumere] : ''
            obj['reference_'+numeroEnumere]= (value.article.hasOwnProperty('reference_'+numeroEnumere) && value.article['reference_'+numeroEnumere]!=null) ? value.article['reference_'+numeroEnumere] : ''
            obj['quantity_'+numeroEnumere]= (value.article.hasOwnProperty('quantity_'+numeroEnumere) && value.article['quantity_'+numeroEnumere]!=null) ? value.article['quantity_'+numeroEnumere] : ''
        }

        props.suppPrice.map((item,index)=>{
            let numero = index+1
            let designation = item['designation_'+numero]

            let articlePriceEntry = value.article.article_price?.find(ap => ap.name === designation)

            let priceHt = ''
            let priceTtc = ''

            if (articlePriceEntry) {
                if (articlePriceEntry.ttc) {
                    priceTtc = articlePriceEntry.value
                    priceHt = value.article.tgc ? Math.round(articlePriceEntry.value / (1 + value.article.tgc / 100) * 100) / 100 : articlePriceEntry.value
                } else {
                    priceHt = articlePriceEntry.value
                    priceTtc = value.article.tgc ? Math.round(articlePriceEntry.value * (1 + value.article.tgc / 100) * 100) / 100 : articlePriceEntry.value
                }
            }

            obj['price_'+designation] = priceHt
            obj['price_'+designation+'_ttc'] = priceTtc
            obj['margeN_'+designation] = (priceHt !== '' && value.article.prmp) ? Math.round((priceHt - value.article.prmp) * 100) / 100 : 0
            obj['margeP_'+designation] = (priceHt !== '' && value.article.prmp && priceHt != 0) ? Math.round((priceHt - value.article.prmp) / priceHt * 100) : 0
        })

        props.categorieTva.map((categorie)=>{
            obj['taux_'+categorie.name]= (value.article.hasOwnProperty('taux_'+categorie.name) && value.article['taux_'+categorie.name]!=null) ? value.article['taux_'+categorie.name] : ''
        })

        datas.push(obj)
    })

    const sizePerPageOptionRenderer = ({
        text,
        page,
        onSizePerPageChange
    }) => (
        <li
            key={ text }
            role="presentation"
            className="dropdown-item"
            onMouseDown={ (e) => {
                e.preventDefault();
                onSizePerPageChange(page);
                setPerPage(page)
            } }
        >
            <a
                href="#"
                tabIndex="-1"
                role="menuitem"
                data-page={ page }
                style={ { color: 'black' } }
            >
                { text }
            </a>
        </li>
    );

    let paginationOptions = {
        paginationSize: 5,
        pageStartIndex: 1,
        firstPageText: t('tableFirst'),
        prePageText: t('tableBack'),
        nextPageText: t('tableNext'),
        lastPageText: t('tableLast'),
        nextPageTitle: t('tableNextTitle'),
        prePageTitle: t('tableBackTitle'),
        firstPageTitle: t('tableFistTitle'),
        lastPageTitle: t('tableLastTitle'),
        sizePerPageOptionRenderer,
        sizePerPage: perPage,
        showTotal: true,
        totalSize: allSupplementListDetailSize
    };

    let columnsInit = [
        {
            dataField: "action",
            text: 'Actions',
            editable: false,
        },
        {
            dataField: "internalid",
            text: t('internalId'),
            hidden: (columnShow.includes("internalid")) ? false : true,
            editable: false,
            sort: true,
        },
        {
            dataField: "max_quantity",
            text: t('maxQuantity'),
            hidden: (columnShow.includes("max_quantity")) ? false : true,
            editable: false,
            sort: true,
        },
        {
            dataField: "article_price_name",
            text: t('priorityPricingCat'),
            hidden: (columnShow.includes("article_price_name")) ? false : true,
            editable: false,
            sort: true,
        },
        {
            dataField: "created_at",
            text: t('createdAt'),
            hidden: (columnShow.includes("created_at")) ? false : true,
            editable: false,
            sort: true,
        },
    ];

    let columns=[
        ...columnsInit,
        ...articleColumnGenerate(articleListErp,columnShow,headerSortingStyle,articleEditionDatatable,props.optionsDataTable,props.ourOptionsDataTable,t,props.authParam),
        ...enumereColumnGenerate(props.maxConditionnement,columnShow,headerSortingStyle,articleEditionDatatable,t,props.authParam),
        ...priceSuppColumnGenerate(props.suppPrice,columnShow,headerSortingStyle,articleEditionDatatable,t,props.authParam),
        ...tauxTvaColumnGenerate(props.categorieTva,columnShow,headerSortingStyle,articleEditionDatatable,t,props.authParam),
        ...customFieldsColumnGenerate(props.customFields,columnShow,headerSortingStyle,articleEditionDatatable,t,props.authParam)
    ]

    // Organisation des columns
    useEffect(function () {
        let columnCookie
        let arrCol = []
            
        if(localStorage.supplement_list_detail_reorganize){
            let newValueToIncludeInCookie
            let cookieLecture = localStorage.supplement_list_detail_reorganize.split(',')

            let already_done=[];
            cookieLecture.map(value=>{
                columns.map(item=>{
                    if(item.dataField==value){
                        arrCol.push(item)
                        already_done.push(value);
                    }
                })
            })
            columns.map(item=>{
                if(!already_done.includes(item.dataField)){ 
                    //si une nouvelle à été ajouté aux customsField, elle n'est pas ajoutée desuite au cookie de reorganisation si celui ci existe
                    //dans le cas où il n'existerait pas, on va créer un nouveau cookie afin de l'inclure pour ne pas avoir d'erreur sur les export 
                    newValueToIncludeInCookie=true
                    arrCol.push(item);
                }
            })

            columnCookie = arrCol
            if(newValueToIncludeInCookie==true){ 
                let arr = []
                arrCol.map(value=>
                    arr.push(value.dataField)
                )
                setLocalStorage("supplement_list_detail_reorganize",arr.join(),{ path: "/", expires: expire_date })
            }
        }else{
            columnCookie = columns
        } 
        setColumnOrganize(columnCookie)
    }, [props.customFields])
    
    // Columns affiché
    useEffect(function () {
        if(localStorage.supplement_list_detail_fields){
            let cookieColumnShow = localStorage.supplement_list_detail_fields.split(',')
            let columnsDatas = [] //contient toutes les dataFields de columns
            let arrColumnShow = [] //contient toutes les données sans doublons
            let arrColumnShowDoublon = [] //contient les doublons
            let arrColumnShowIntrus = [] // continent les fausse données

            columns.map(item=>{
                columnsDatas.push(item.dataField)
            })

            cookieColumnShow.map(value=>{
                //on vérifie si le cookie contien des doublons
                if(!arrColumnShow.includes(value)){
                    arrColumnShow.push(value)
                }else{
                    //Si value existe dejà c'est qu'il y a un doublon 
                    arrColumnShowDoublon.push(value)
                }
                //on vérifie si les données du cookies sont des données qui exisent dans le tableau columns
                if(!columnsDatas.includes(value)) arrColumnShowIntrus.push(value)
                
            })

            if(arrColumnShowDoublon.length!=0 || arrColumnShowIntrus.length!=0){ 
                //Si le cookie contient des doublons et des données qui n'existe pas en meme temps
                let uniformData = arrColumnShow.filter(value=> !arrColumnShowIntrus.includes(value))

                setLocalStorage("supplement_list_detail_fields",uniformData.join(),{ path: "/", expires: expire_date })
            }
        }
    }, [])

    const handleToggleColumns = (column,indexToEdit) => {
        if(column.toggle){
            var newColumnShow = columnShow.filter(value=>value!=column.dataField)

            //Modification pour la mise à jour des status hidden de chaque colonnes
            let dataColumn = columnOrganize.filter(value=>value.dataField!=column.dataField)
            let newData = column
            newData.hidden = true

            dataColumn.splice(indexToEdit,0, newData)

            setColumnOrganize(dataColumn)
            //End

            setColumnShow(newColumnShow)
            
        }
        else{
            var newColumnShow = [...columnShow,column.dataField]

            //Modification pour la mise à jour des status hidden de chaque colonnes
            let dataColumn = columnOrganize.filter(value=>value.dataField!=column.dataField)
            let newData = column
            newData.hidden = false

            dataColumn.splice(indexToEdit,0, newData)

            setColumnOrganize(dataColumn)
            //End

            setColumnShow(newColumnShow)
        }
        setLocalStorage("supplement_list_detail_fields",newColumnShow.join(),{ path: "/", expires: expire_date }) 
    }

    if(loading){
        return (<Loading></Loading>);
    }
    return ( <>
        <ModalSelectArticlePrice
            show={showEditPriceModal}
            article={editingDetail?.article}
            selectedPriceId={selectedEditPriceId}
            onSelectPrice={setSelectedEditPriceId}
            onConfirm={handleConfirmEditPrice}
            onCancel={()=>{setShowEditPriceModal(false);setEditingDetail(null);setSelectedEditPriceId(null)}}
            loading={loadingEditModal}
        />
        <ToastPopUp
            showToast={toast}
            setShowToast={setToast}
            message={t('favoriteSaved')}
        />
        <Modal show={showCarousel} onHide={()=>closeModalCarousel()}>
            <Modal.Header closeButton>
                <Modal.Title>{modalItemName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <CarouselImage images={modalImage} />
            </Modal.Body>
        </Modal>
        <Tabs activeKey={table} id="uncontrolled-tab-example" onSelect={(k)=>setTable(k)}>
            <Tab eventKey="article" title={t('items')}>
                <FormulaireAjoutArticleSupplementList 
                    liaisons={props.liaisons}
                    customFields={props.customFields} 
                    setToast={setToast}
                    customInterface={props.customInterface}
                    setCustomInterface={props.setCustomInterface}
                    setReload={setReloadData}
                    allSupplementListDetail={allSupplementListDetail}
                    supplementListId={supplementListId}
                />
                <CardPerso header={
                    <>
                        {(listName) ? t('listOfItems')+' : '+listName : t('listOfItems')+' : '}&nbsp;&nbsp;
                    </>
                }>
                    <small>
                        <ToolkitProvider
                            keyField="index"
                            data={datas}
                            columnToggle
                            columns={columnOrganize}
                            key={allSupplementListDetailSize}
                        >
                        {(propst) => (
                            <>
                                <div className="row mb-3 d-flex justify-content-between">
                                    <div className="col d-flex align-items-baseline">
                                        <ColumDataTableReorganize 
                                            columnOrganize={columnOrganize}
                                            setColumnOrganize={setColumnOrganize}
                                            setCookie={setLocalStorage}
                                            cookieName='supplement_list_detail_reorganize'
                                            { ...propst.columnToggleProps } 
                                            executWhenToggle={handleToggleColumns}
                                            showColumnOrganize={showColumnOrganize}
                                            setShowColumnOrganize={setShowColumnOrganize}
                                            btnSwitch={true}//pour affiche ou non le btn swith
                                            initSwith={false}//initialier à false il affichera par défaut le toggle des colonnes, sur true il affichera le drag and drop pour changer la position des colonnes
                                        />&nbsp;&nbsp;&nbsp;
                                        <ExportArticleButton filtre={{}} lang={lang.lang} addMark={addMark} header={headerColumnShowExport} title={t('downloadCSVSelection')} type="button" url={"api/erp/supplement_list/csv_list/"+id}></ExportArticleButton>&nbsp;&nbsp;&nbsp;
                                        <ExportArticleButton filtre={{}} lang={lang.lang} addMark={addMark} header={headerAllExport} title={t('downloadCSVAll')} type="button" url={"api/erp/supplement_list/csv_list/"+id}></ExportArticleButton>&nbsp;&nbsp;&nbsp;
                                        <AddMarkExportForm setAddMark={setAddMark} addMark={addMark} />&nbsp;&nbsp;&nbsp;
                                    </div>
                                    {showButtonValidate && 
                                        <div className="col-12 mt-2">
                                            <button 
                                                disabled={validButton} 
                                                className="btn btn-primary" 
                                                onClick={()=>handleSubmitEditQte()} 
                                            >
                                                {validButton ? <div className="spinner-border spinner-border-sm"></div> : t('validateModif')}
                                            </button>
                                        </div>
                                    }
                                </div>
                                <div className="position-relative">
                                    <CustomDataTable 
                                        propst={propst}
                                        paginationOptions={paginationOptions}
                                        columnShow={columnShow}
                                        defaultSortDirection="asc"
                                    />
                                </div>
                            </>
                        )}
                        </ToolkitProvider>
                    </small>
                </CardPerso>
            </Tab>
            <Tab eventKey="importItem" title={t('importItem')}>
                <ImportArticleSupplementList id={id} listName={listName} CardTitle={'importItemSupplementList'} />
            </Tab>
        </Tabs>
    </>);
}

export default ItemsSupplementListDetailTable;
